import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { fetchWikiContent } from '../utils/api';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { ErrorMessage } from '../components/common/ErrorMessage';
import { NoDataMessage } from '../components/common/NoDataMessage';
import { useAlbum } from '../contexts/AlbumContext';
import AlbumView from '../components/features/album/AlbumView';

const Today = () => {
  const { currentAlbum, loading: albumLoading, error: albumError, hasProject } = useAlbum();
  const [wikiContent, setWikiContent] = useState('');
  const [wikiLoading, setWikiLoading] = useState(false);
  const [wikiError, setWikiError] = useState(null);

  useEffect(() => {
    const loadWikiContent = async () => {
      if (currentAlbum?.wikipediaUrl) {
        setWikiLoading(true);
        try {
          const content = await fetchWikiContent(currentAlbum.wikipediaUrl);
          setWikiContent(content);
        } catch (err) {
          setWikiError(err.message);
        } finally {
          setWikiLoading(false);
        }
      }
    };
    
    loadWikiContent();
  }, [currentAlbum]);

  // Redirect if no project
  if (!hasProject) {
    return <Navigate to="/settings" replace />;
  }

  if (albumLoading || wikiLoading) {
    return (
      <div className="flex items-center justify-center w-full min-h-screen">
      <LoadingSpinner />
      </div>
    );
  }
  if (albumError) return <ErrorMessage message={albumError} />;
  if (!currentAlbum) return <NoDataMessage />;

  return (
    <AlbumView 
      album={currentAlbum}
      wikiContent={wikiContent}
      wikiError={wikiError}
    />
  );
};

export default Today;